import React from 'react';
import { Form, Input, Button } from 'antd';
import { message } from '../services/toastMessage';
import { useTranslation } from 'react-i18next';
import { updatePassword } from '../services/AuthenticationService';
import { TRANSLATIONS } from '../constants/translations';
import { translate } from '../helpers/translationHelper';

interface ResetPasswordFormProps {
    token: string | null;
    email: string | null;
  }

const ResetPasswordForm: React.FC<ResetPasswordFormProps> = ({token, email}) => {
  const { t } = useTranslation();

  const onFinish = async (values: { password: string; confirmPassword: string }) => {
    if (values.password !== values.confirmPassword) {
      message.error(translate(t, TRANSLATIONS.RESET_PASSWORD_MISMATCH_ERROR));
      return;
    }

    try {
      // Replace with actual reset password logic
      await updatePassword(values.password, token, email);
      console.log('Password reset successfully:', values.password);
      message.success(translate(t, TRANSLATIONS.RESET_PASSWORD_SUCCESS));
    } catch (error) {
      message.error(translate(t, TRANSLATIONS.RESET_PASSWORD_ERROR_FALLBACK));
    }
  };

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
      <div style={{ maxWidth: 400, width: '100%', padding: '0 16px' }}>
        <h1 style={{ textAlign: 'center' }}>{translate(t, TRANSLATIONS.RESET_PASSWORD_TITLE)}</h1>
        <Form layout="vertical" onFinish={onFinish}>
          <Form.Item
            label={translate(t, TRANSLATIONS.RESET_PASSWORD_NEW_LABEL)}
            name="password"
            rules={[{ required: true, message: translate(t, TRANSLATIONS.RESET_PASSWORD_NEW_REQUIRED) }]}
          >
            <Input.Password />
          </Form.Item>
          <Form.Item
            label={translate(t, TRANSLATIONS.RESET_PASSWORD_CONFIRM_LABEL)}
            name="confirmPassword"
            dependencies={['password']}
            rules={[
              { required: true, message: translate(t, TRANSLATIONS.RESET_PASSWORD_CONFIRM_REQUIRED) },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('password') === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error(translate(t, TRANSLATIONS.RESET_PASSWORD_CONFIRM_MISMATCH)));
                },
              }),
            ]}
          >
            <Input.Password />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" block>
              {translate(t, TRANSLATIONS.RESET_PASSWORD_SUBMIT_BUTTON)}
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

export default ResetPasswordForm;
